export const conditionSections = [
  {
    title: "1. CO₂削減量の算出方法",
    content: [
      "● 試算概要",
      "従来の火力発電を中心とした電力プランから、再エネ100％または実質再エネ100％プランに切り替えた場合、年間で約1.7トンのCO₂削減が見込まれます。",
      "● 算出ロジック",
      "年間CO₂排出量 ＝ 年間電力使用量 × CO₂排出係数",
      "再エネ電力による排出量を実質ゼロとみなし、従来プランとの差分を削減量として算出",
      "● 使用データ",
      "年間電力使用量：3,950 kWh／年",
      "　出典：環境省「令和４年度 家庭部門のCO₂排出実態統計調査」(https://www.env.go.jp/earth/ondanka/ghg/kateiCO2tokei_00004.html)",
      "CO₂排出係数：0.434 kg-CO₂／kWh",
      "　出典：環境省「令和5年算定方法・排出係数一覧」(https://policies.env.go.jp/earth/ghg-santeikohyo/files/calc/r05_coefficient_rev4.pdf)",
      "　※一般送配電事業者の調整後排出係数",
      "● 算出結果",
      "【基準値試算】",
      "3,950 × 0.434 ＝ 1,714.3 kg-CO₂",
      "≒ 1.7トン-CO₂／年",
      "【簡易診断に基づく試算】",
      "3.にて算出した年間電力使用量× 0.434 ÷ 2.にて算出したCO₂削減量の身近な例",
      "【詳細診断に基づく試算】",
      "入力された年間電力使用量× 0.434 ÷ 2.にて算出したCO₂削減量の身近な例"
    ]
  },
  {
    title: "2. CO₂削減量の身近な例との比較",
    content: [
      "年間1.7トンのCO₂削減量を、以下のような身近な対象に換算すると以下の通りです。",
      "● ペットボトル（500ml）換算",
      "  CO₂排出量：119 g-CO₂／本",
      "  → 約14,286本分の排出に相当",
      "  出典：環境省「リユース可能な飲料容器に係る分析」(https://www.env.go.jp/recycle/yoki/c_3_report/pdf/h23_lca_01.pdf)",
      "● ガソリン換算",
      "  CO₂排出量：2.322 kg-CO₂／L",
      "  → 約732リットル分に相当",
      "  出典：環境省「燃料別の二酸化炭素排出量の例」(https://www.env.go.jp/council/16pol-ear/y164-04/mat04.pdf)",
      "● 桜の木（広葉樹）による年間吸収量換算",
      "  吸収量：3.7 kg-CO₂／本・年",
      "  → 約459本分の年間吸収に相当",
      "  出典：林野庁「地球温暖化防止に向けて > よくある質問」(https://www.env.go.jp/council/16pol-ear/y164-04/mat04.pdf)より推計",
      "  ※1ヘクタールあたりの広葉樹林の年間吸収量（約3.67トン）を、植栽密度1,000本／haとして均等割"
    ]
  },
  {
    title: "3. 月別の年間電力使用量の推計方法",
    content: [
      "本シミュレーションの簡易診断では、以下の3要素を組み合わせて、世帯ごとの年間電力使用量を推計しています。",
      "① 世帯構成別の月別平均電力使用量",
      "  出典：東京都「平成26年 家庭のエネルギー消費動向実態調査」(https://www.kankyo.metro.tokyo.lg.jp/documents/d/kankyo/home-energy-files-syouhidoukouzittaityousa26honpen_3)",
      "  ※集合住宅と戸建てを合算した平均値を使用 (P46-P47)",
      "② 電力使用傾向による調整係数",
      "  ・普通（基準）＝1.00",
      "  ・少ない方＝0.65",
      "  ・多い方＝1.35",
      "  ※同調査のクラス2〜4の区分から算出",
      "③ オール電化の有無による調整係数",
      "  ・オール電化住宅＝1.5",
      "  ・非オール電化住宅＝1.0",
      "  ※出典：関西電力「オール電化世帯別平均電気代」(https://kepco.jp/denka/article_family_average/)"
    ]
  },
  {
    title: "4. 電気料金(月平均)の計算方法",
    content: [
      "「電気料金（月平均）」は、選択された世帯構成等条件に基づく、一般的な電気使用量を算出後、インプットとしているデータに基づき、月別の電気料金を算出後、過去1年分を平均して算出しています。",
      "● インプットとしているデータ",
      "  パートナー企業より提供された当該電気プランの",
      "  ・最新の基本料金",
      "  ・最新の従量料金単価",
      "  ・過去12カ月分の燃料費調整費・電源調達費 (政府補助金等が適用されている月は補助金適用後の数字を利用）",
      "  ・最新年度の再エネ賦課金",
      "● 計算方法",
      "  ・前項の「月別の年間電力使用量」に対して、基本料金・従量料金・燃料調整費等・再エネ賦課金を算出し、各月の電気料金総額を算出。",
      "  ・12カ月分の電気料金総額を合算。(電気料金総額(年間))",
      "  ・電気料金総額(年間)を12で割り、電気料金(月平均) を算出。",
      "● その他前提事項",
      "  ・再生可能エネルギー発電促進賦課金単価は4.18円／kWhで計算しています。",
      "  ・政府の電気料金支援に関しましては、2026年12月使用（1月検針分）から1.0円/kWh、2027年1月使用分（2月検針分）及び2027年2月使用分（3月検針分）から4.5円/kWhの値引きが行われます。本シミュレーション結果は、2026年10月使用分（11月電気代）までのデータが含まれており、2026年12月使用（1月検針分）以降の値引きは含まれておりません。"
    ]
  },
  {
    title: "5. 注意事項",
    content: [
      "本ページで使用している「3,950 kWh／年」は全国平均値です。診断では、個別の世帯条件に応じた電力使用量を推計します。",
      "CO₂削減量は全国平均のデータに基づく一例であり、地域や契約条件により実際の削減効果は異なる場合があります。",
      "本ページの記載内容は2026年10月末時点の公開情報をもとに構成しています。"
    ]
  }
];